import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { IReport, VendorActivity } from '../models';

@Injectable({
  providedIn: 'root'
})
export class VendorActivityService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

   

      //  public deleteReport(reportId:number):Observable<any> {
      //     return this.apiService.delete(`VendorActivityReport/${reportId}`)
      // }

      public ExportVendorActivityResult(vendorActivitySearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}VendorActivityReport/ExportVendorActivity`, vendorActivitySearchParam,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
      public getClientNames(): Observable<any> {
        return this.apiService.get(`ReportVendorActivity/ClientCompanyListForReport`);
      }
      public getVendorNames(): Observable<any> {
        return this.apiService.get(`ReportVendorActivity/VendorCompanyListForReport`);
       }
       public generateSummaryReport(value: IReport): Observable<any> {
        return this.apiService.post(`ReportVendorActivity/Summarylist`, value);
       }
       public exportSummaryReport(value: IReport): Observable<any> {
        return this.http.post(`${environment.apiRoot}ReportVendorActivity/ExportSummarylist`,
        value ,
        {  
            responseType: 'blob',
            observe: 'response'
         });
       }
       public generateDetailedReport(value: IReport): Observable<any> {
        return this.apiService.post(`ReportVendorActivity/Detailedlist`, value);
       }
  
}
